import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'

export const TabPanelContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isVisible'
})(({isVisible}) => ({
  display: isVisible ? 'block' : 'none',
  height: '100%'
}))
